import fs from 'fs'
import path from 'path'

describe('SaaS 登录页迁移入口', () => {
  const loginSource = fs.readFileSync(path.resolve(__dirname, '../userlogin.vue'), 'utf8')
  const homeSource = fs.readFileSync(path.resolve(__dirname, '../../../views/wel/index.vue'), 'utf8')
  const websiteSource = fs.readFileSync(path.resolve(__dirname, '../../../config/website.js'), 'utf8')

  it('在登录页复用旧登录并提交四个迁移字段', () => {
    expect(loginSource).toContain('登录并进入新后台')
    expect(loginSource).toContain('@click.native.prevent="handleLegacyMigration"')
    expect(loginSource).toContain("await this.$store.dispatch('LoginByUsername', this.loginForm)")
    expect(loginSource).toContain('const legacyToken = this.$store.state.user.token')
    expect(loginSource).toContain("legacy_source: 'saas'")
    expect(loginSource).toContain('username: this.loginForm.username')
    expect(loginSource).toContain('raw_password: this.loginForm.password')
    expect(loginSource).toContain('legacy_token: legacyToken')
  })

  it('首页不再承载迁移入口', () => {
    expect(homeSource).not.toContain('legacyMigrationMixin')
    expect(homeSource).not.toContain('进入新版后台')
  })

  it('迁移按钮使用醒目样式', () => {
    expect(loginSource).toContain('<el-button type="warning" @click.native.prevent="handleLegacyMigration" class="login-submit legacy-migration-submit">')
    expect(loginSource).toContain('.legacy-migration-submit')
  })

  it('登录页隐藏租户输入框并使用后台返回的固定租户', () => {
    expect(loginSource).toContain('tenantMode: false')
    expect(loginSource).toContain('tenantId: this.website.tenantId')
    expect(loginSource).toContain('this.loginForm.tenantId = data.data.tenantId')
    expect(websiteSource).toContain("tenantId: '093154'")
  })
})
